module.exports = __webpack_public_path__ + "./SerenePhoto_3a680c36795102bbdd49bf72355b8d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/SerenePhoto.png
// module id = 487
// module chunks = 0